module.exports = __webpack_public_path__ + "img/coronavirus.336b4a1c.jpg";